import { render } from "./AdminListPage.vue?vue&type=template&id=9297e7e0&scoped=true"
import script from "./AdminListPage.vue?vue&type=script&lang=js"
export * from "./AdminListPage.vue?vue&type=script&lang=js"

import "./AdminListPage.vue?vue&type=style&index=0&id=9297e7e0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9297e7e0"

export default script